import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema, FAQPageSchema } from '@/components/feature/StructuredData';

export default function AboutPage() {
  return (
    <>
      <OrganizationSchema />
      <WebPageSchema
        title="关于我们 - 91在线视频"
        description="91在线视频是国内领先的娱乐资讯与吃瓜爆料平台，致力于为用户提供最新、最全、最真实的网红黑料与热门事件追踪内容。"
        url="https://www.91zaixianshipin.com/about"
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.91zaixianshipin.com/' },
          { name: '关于我们', url: 'https://www.91zaixianshipin.com/about' },
        ]}
      />
      <FAQPageSchema
        questions={[
          {
            question: '91在线视频是什么平台？',
            answer: '91在线视频是国内领先的娱乐资讯与吃瓜爆料平台，提供网红黑料、热门事件追踪和娱乐圈八卦内容。',
          },
          {
            question: '如何下载91在线视频APP？',
            answer: '您可以访问官网下载页面，支持Android和iOS系统。APP版本为v3.2.1，安全无毒。',
          },
          {
            question: '如何联系91在线视频？',
            answer: '您可以通过电子邮箱contact@91zaixianshipin.com或客服热线400-888-9191联系我们。',
          },
          {
            question: '91在线视频的内容是否可靠？',
            answer: '我们致力于提供真实可靠的内容，但由于部分信息来源于网络爆料，建议读者理性看待。',
          },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <nav className="w-full px-4 md:px-6 py-4" aria-label="面包屑导航">
          <div className="max-w-7xl mx-auto">
            <ol className="flex items-center gap-2 text-xs text-foreground-500">
              <li>
                <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </li>
              <li>
                <span className="text-foreground-800 font-medium">关于我们</span>
              </li>
            </ol>
          </div>
        </nav>

        <section className="bg-background-50 py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 items-center">
                <div className="lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20media%20office%20workspace%20with%20warm%20ambient%20lighting%20elegant%20interior%20design%20collaborative%20atmosphere%20abstract%20artistic%20background%20with%20subtle%20red%20and%20gold%20accents%20editorial%20photography%20sophisticated%20aesthetic&width=1000&height=750&seq=about-brand-01&orientation=landscape"
                      alt="91在线视频品牌形象"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 left-4 flex gap-2">
                      <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                        关于
                      </span>
                      <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                        信誉
                      </span>
                      <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                        联系
                      </span>
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
                    91在线视频 — 全网最热吃瓜爆料平台
                  </h1>
                  <p className="text-base text-foreground-600 leading-relaxed mb-6">
                    91在线视频是国内领先的娱乐资讯与吃瓜爆料平台，致力于为用户提供最新、最全、最真实的网红黑料、热门事件追踪与娱乐圈八卦内容。我们以专业的内容采编能力和敏锐的热点嗅觉，为您带来第一手的独家爆料。
                  </p>
                  <div className="flex flex-wrap gap-2 mb-8">
                    <span className="px-3 py-1 rounded-full border border-foreground-200 text-xs text-foreground-600 whitespace-nowrap">独家爆料</span>
                    <span className="px-3 py-1 rounded-full text-xs text-foreground-600 whitespace-nowrap">实时追踪</span>
                    <span className="px-3 py-1 rounded-full text-xs text-foreground-600 whitespace-nowrap">专业采编</span>
                    <span className="px-3 py-1 rounded-full text-xs text-foreground-600 whitespace-nowrap">全网最热</span>
                  </div>

                  <div className="bg-foreground-950 rounded-xl p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap">
                        品牌档案
                      </span>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-building-line text-background-50 text-sm"></i>
                        </div>
                        <div>
                          <h4 className="text-sm text-background-50 font-label font-semibold">品牌定位</h4>
                          <p className="text-xs text-background-50/60 mt-0.5 leading-relaxed">
                            国内领先的娱乐资讯平台，专注于网红黑料、吃瓜爆料与热门事件追踪
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-shield-check-line text-background-50 text-sm"></i>
                        </div>
                        <div>
                          <h4 className="text-sm text-background-50 font-label font-semibold">内容理念</h4>
                          <p className="text-xs text-background-50/60 mt-0.5 leading-relaxed">
                            坚持真实、及时、有态度的内容原则，为用户提供高质量的娱乐资讯服务
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-mail-line text-background-50 text-sm"></i>
                        </div>
                        <div>
                          <h4 className="text-sm text-background-50 font-label font-semibold">联系我们</h4>
                          <p className="text-xs text-background-50/60 mt-0.5 leading-relaxed">
                            商务合作：business@91zaixianshipin.com<br />
                            内容投稿：tips@91zaixianshipin.com
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-16 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
                用户口碑
              </h2>
              <p className="text-center text-foreground-500 mb-12 max-w-xl mx-auto">
                来自真实用户的使用评价，是我们不断前进的最大动力
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-lg p-6">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "吃瓜速度是真的快！每次有大事件发生，91视频都是第一个更新的。现在每天都要刷几遍，已经离不开这个平台了。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%20avatar%20warm%20natural%20lighting%20clean%20background%20simple%20expression%20editorial%20photography&width=64&height=64&seq=avatar-review-01&orientation=squarish"
                        alt="用户头像"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-xs font-label font-semibold text-foreground-950">吃瓜小能手</p>
                      <p className="text-xs text-foreground-500">活跃用户 · 6个月</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-50 rounded-lg p-6">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "APP用起来非常流畅，界面设计也很清爽。最重要的是内容质量高，不是那种标题党，每次爆料都有理有据。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20portrait%20avatar%20casual%20expression%20natural%20light%20neutral%20background%20editorial%20photography&width=64&height=64&seq=avatar-review-02&orientation=squarish"
                        alt="用户头像"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-xs font-label font-semibold text-foreground-950">八卦雷达站</p>
                      <p className="text-xs text-foreground-500">活跃用户 · 1年</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-50 rounded-lg p-6">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: 4 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                    <i className="ri-star-line text-accent-500 text-sm"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "内容更新速度没得说，就是希望评论区的管理能再严格一点。整体来说还是很推荐的，身边朋友都在用。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Mature%20Chinese%20person%20portrait%20avatar%20serious%20expression%20professional%20lighting%20clean%20background%20editorial%20photography&width=64&height=64&seq=avatar-review-03&orientation=squarish"
                        alt="用户头像"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-xs font-label font-semibold text-foreground-950">理性吃瓜人</p>
                      <p className="text-xs text-foreground-500">活跃用户 · 3个月</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-16 md:py-24">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <div className="relative rounded-2xl overflow-hidden mb-10 aspect-[16/9]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20office%20contact%20center%20warm%20ambient%20lighting%20professional%20atmosphere%20abstract%20artistic%20visual%20with%20red%20and%20gold%20accents%20cinematic%20editorial%20photography%20sophisticated%20corporate%20aesthetic&width=1200&height=675&seq=about-contact-01&orientation=landscape"
                  alt="91在线视频联系方式"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>

              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
                联系
              </h2>
              <p className="text-xl md:text-2xl font-heading text-foreground-600 mb-2 italic">
                我们
              </p>
              <p className="text-base text-foreground-500 mb-8">
                如果您有任何问题、建议或商务合作意向，欢迎随时联系我们
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
                <a
                  href="mailto:business@91zaixianshipin.com"
                  className="px-10 py-3.5 rounded-full bg-foreground-950 text-background-50 font-label font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-send-line mr-2"></i>
                  商务合作
                </a>
                <a
                  href="mailto:tips@91zaixianshipin.com"
                  className="px-10 py-3.5 rounded-full border border-foreground-200 text-foreground-700 font-label font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-chat-1-line mr-2"></i>
                  内容投稿
                </a>
              </div>

              <div className="bg-background-100 rounded-xl p-8 max-w-2xl mx-auto">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-6">联系方式</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 text-left">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                      <p className="text-sm text-foreground-950 font-label">contact@91zaixianshipin.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">客服热线</p>
                      <p className="text-sm text-foreground-950 font-label">400-888-9191</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-secondary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">微信公众号</p>
                      <p className="text-sm text-foreground-950 font-label">91在线视频官微</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-weibo-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">官方微博</p>
                      <p className="text-sm text-foreground-950 font-label">@91在线视频</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}